import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigService } from './app-config.service';
import { CrazyCallConfigService } from './crazycall-config.service';

@Injectable()
export class LivePreviewService {
  constructor(
    private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService,
    private crazyCallConfigService: CrazyCallConfigService
  ) {}

  createPreviewHtml(settings: Object) {
    let settingsToString = '';
    Object.keys(settings).forEach(settingsKey => {
      settingsToString += `${settingsKey}: ${settings[settingsKey]},`;
    });
    return this.sanitizer.bypassSecurityTrustHtml(`
      <script>
        window.ChannelsSettings = {
          appId: "${this.crazyCallConfigService.appId}",
          ${settingsToString}
        };
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "${this.appConfigService.WEB_CALL_SCRIPT_URL}";
        document.getElementsByTagName("head")[0].appendChild(script);
      </script>
    `);
  }

  sendToFrame(state: string, payload?: any, id = 'widgetLive') {
    const iframe: any = document.getElementById('widgetLive');
    const msg = {
      type: state,
      meta: {
        isPostMessageAction: true
      },
      payload: payload
    };
    if (iframe) {
      iframe.contentWindow.postMessage(msg, '*');
    }
  }
}
